import {connect} from 'react-redux';
import SignInComponent from '../../Components/Auth/SignIn';
import {userLogin} from '../../redux/actions/AuthActions';

const AuthContainer = connect (
    (state) => {
        return {
            user: state.authReducer
        };
    },
    (dispatch) => {
        return {
            userLogin: (email,password) => {
                dispatch(userLogin(email,password));
            }
        };
    }
)(SignInComponent);

export default AuthContainer;